module.exports = __webpack_public_path__ + "img/1f640.581a353.svg";